module.exports = __webpack_public_path__ + "images/64fdd1aa0d0ecc36ab542ee06326816d.png";